import useVideoControl from '@/hooks/useVideoControl';
import { ProtectedRoute } from '@/ProtectedRoute';
import { theme, theme2 } from '@/theme';
import { ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import { clsx } from 'clsx';
import { createContext, Dispatch, SetStateAction, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FilterBar } from '../FilterBar';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { NavBar } from '../Navbar';
import './index.scss';
type LayoutContextProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
};
export const LobbyLayoutContext = createContext({} as LayoutContextProps);
export const LobbyLayout = () => {
    useVideoControl();
    const [open, setOpen] = useState(false);
    return (
        <ProtectedRoute>
            <LobbyLayoutContext.Provider value={{ open, setOpen }}>
                <ThemeProvider theme={open ? theme2 : theme}>
                    <Box
                        className={clsx(
                            'screen-container',
                            'mx-auto',
                            open ? 'expand-side-bar' : 'side-bar'
                        )}
                    >
                        <Header />
                        <FilterBar />
                        <NavBar />
                        <Box className={'lobby-outlet'}>
                            <Outlet />
                        </Box>
                        <Footer />
                    </Box>
                </ThemeProvider>
            </LobbyLayoutContext.Provider>
        </ProtectedRoute>
    );
};
